import * as React from 'react';
import "./../../dashboard-energy-banker/energy-banker-time-log/energy-banker-time-log.scss";
import { DashboardGridSkeletonRectangle } from '../../../dashboard-skeletons/dashboard-skeleton-rectangle';
import PropTypes from 'prop-types';
import EnergyProjectHoursByVerticalChart from './energy-project-hours-by-vertical-chart';
import EnergyProjectHoursByVerticalHeader from './energy-project-hours-by-vertical-header';
import { useFluentToast } from '../../../../../components/FluentUI/Fluent-Toast';

const EnergyProjectHoursByVertical = ({
  energyProjectHoursByVerticalData,
  fetchEnergyProjectHoursByVertical,
  setIsEnergyProjectHoursByVerticalLoading,
  isEnergyProjectHoursByVerticalLoading,
}) => {
  const chartRef = React.useRef(null);
  const [expandClass, setExpandClass] = React.useState("");
  const [period, setPeriod] = React.useState(8);
  const { showToast, FluentToast } = useFluentToast("bottom", true);


  const expandWidget = () => {
    setExpandClass(expandClass === "" ? "widgetExpanded" : "");
  };
  const onPeriodChange = (newPeriod) => {
    setIsEnergyProjectHoursByVerticalLoading(true);
    setPeriod(newPeriod);
    fetchEnergyProjectHoursByVertical(newPeriod)
      .finally(() => setIsEnergyProjectHoursByVerticalLoading(false));
  };

  return (
    <div className={`energy-banker-time-log energy-staffing-index ${expandClass} dashboard-container-shadow p-1`}>
      <EnergyProjectHoursByVerticalHeader expandClass={expandClass} expandWidget={expandWidget} onPeriodChange={onPeriodChange} period={period} energyProjectHoursByVerticalData={energyProjectHoursByVerticalData} chartRef={chartRef} showToast={showToast} />
      {isEnergyProjectHoursByVerticalLoading ?
        <DashboardGridSkeletonRectangle width="95vw" />
        :
        energyProjectHoursByVerticalData &&
        <EnergyProjectHoursByVerticalChart energyProjectHoursByVerticalData={energyProjectHoursByVerticalData} chartRef={chartRef} />}
      <div className="position-relative">{FluentToast}</div>
    </div>
  );
};

EnergyProjectHoursByVertical.propTypes = {
  energyProjectHoursByVerticalData: PropTypes.shape({
    ChartData: PropTypes.arrayOf(
      PropTypes.shape({
        Date: PropTypes.string,
        Sectors: PropTypes.arrayOf(
          PropTypes.shape({
            SectorName: PropTypes.string,
            Hours: PropTypes.number,
          })
        ),
      })
    ),
  }),
  fetchEnergyProjectHoursByVertical: PropTypes.func,
  setIsEnergyProjectHoursByVerticalLoading: PropTypes.func,
  isEnergyProjectHoursByVerticalLoading: PropTypes.bool,
};

export default EnergyProjectHoursByVertical;